import { SimpleResponse } from 'Types/simpleResponse'
import { ResponseCatalog, RequestParams } from 'Models'
import { urls } from 'Src/constants/Urls'
import { ChannelStructureModel } from 'Pages/referenceBooks'
import { axiosDS } from '@pp/axios'

export const channelStructureApi = {
	getAll: async (params?: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<ChannelStructureModel>>(
			urls.referenceBook.channelStructure,
			{ params }
		)
		return res.data
	},

	getExcel: async (params?: RequestParams) => {
		const res = await axiosDS().get<SimpleResponse>(urls.referenceBook.channelExcel, { params })
		return res.data
	},
}
